var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimizeCv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.481V13.1477M16.5 13.1477H19.8333M16.5 13.1477L20.6667 17.3144M11.5 16.481V13.1477M11.5 13.1477H8.16666M11.5 13.1477L7.33333 17.3144M16.5 5.16659V8.49992M16.5 8.49992H19.8333M16.5 8.49992L20.6667 4.33325M11.5 8.49992L7.33333 4.33325M11.5 8.49992V5.16659M11.5 8.49992H8.16666",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizeCv);
export default __webpack_public_path__ + "static/media/minimizeCV.fa3ef6ae42cfec5af21f068a6c5818e5.svg";
export { ForwardRef as ReactComponent };